import { createSelector } from 'reselect'

import { selectCurrentContact } from 'ducks/crm/contacts/selectors/current'

import { COMPANY_PAGE } from '../../pages'
import { selectCompaniesById } from './base'

export function selectCompanyPageCompanyId(state) {
  if (state.location.type === COMPANY_PAGE) {
    return state.location.payload.id || null
  }
  return null
}

export const selectCurrentCompanyId = createSelector(
  selectCompanyPageCompanyId,
  selectCurrentContact,
  (companyPageCompanyId, contact) => {
    return (
      companyPageCompanyId ||
      (contact && contact.companies && contact.companies[0]?.id)
    )
  }
)
export const selectCurrentCompany = createSelector(
  selectCurrentCompanyId,
  selectCompaniesById,
  (id, byId) => {
    return id && (byId[id] || { id })
  }
)
